import { render, staticRenderFns } from "./BlogWall.vue?vue&type=template&id=3713c12f&scoped=true&"
import script from "./BlogWall.vue?vue&type=script&lang=js&"
export * from "./BlogWall.vue?vue&type=script&lang=js&"
import style0 from "./BlogWall.vue?vue&type=style&index=0&id=3713c12f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3713c12f",
  null
  
)

export default component.exports